<template>
  <div>
    <h4>Financeiro</h4>
    <RelatorioEmpresasSelector />
    <b-row>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Contas Receber:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial"
                    label-for="data_inicial"
                    label="Data Inicial Venc."
                  >
                    <b-form-input type="date" v-model="data_inicial">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final"
                    label-for="data_final"
                    label="Data Final Venc."
                  >
                    <b-form-input type="date" v-model="data_final">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    id="statusSelecionadoReceber"
                    label-for="statusSelecionadoReceber"
                    label="Status"
                    class="mr-5"
                  >
                    <b-form-select v-model="statusSelecionadoReceber">
                      <b-form-select-option
                        v-for="s in statusContaReceber"
                        :key="s.id + 'status'"
                        :value="s.descricao"
                      >
                        {{ s.descricao }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Cliente" label-for="nome">
                    <VueSelect
                      ref="buscarCliente"
                      :filterable="false"
                      @input="setClienteContaReceber"
                      :options="clientes"
                      @search="onSearchCliente"
                      v-model="cliente_conta_receber"
                    >
                      <template slot="no-options">
                        Informe o nome do cliente
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.nome }}
                          </div>
                          <span class="text-muted">{{
                            formatCpfCnpj(option.cnpj_cpf)
                          }}</span>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group
                    label="Escolha a ordenação"
                    label-for="ordenacao"
                  >
                    <select
                      name="ordenacao_conta_receber"
                      id="ordenacao_conta_receber"
                      v-model="ordenacao_conta_receber"
                      class="form-control"
                    >
                      <option
                        v-for="(o, index) in ordenar_conta_receber"
                        :value="o.campo"
                        :key="'campo' + index"
                      >
                        {{ o.descricao }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Formas de pagamento" label-for="meios_pagamento_receber">
                    <VueSelect
                      id="meios_pagamento_receber"
                      v-model="meiosPagamentoSelecionados"
                      :options="meiosPagamento"
                      label="descricao"
                      multiple
                      placeholder="Todas as formas de pagamento"
                    />
                  </b-form-group>
                </b-col>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Considerar pela data de recebimento
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="data_recebimento" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Simplificado
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="formato_simplificado" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
              </b-row>
              <b-dropdown text="Gerar relatório" variant="primary">
                <b-dropdown-item @click="gerarContasReceber(false)">PDF</b-dropdown-item>
                <b-dropdown-item @click="gerarContasReceber(true)">Excel</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-form>
        </div>
      </b-col>

      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Contas a Pagar:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_pagar"
                    label-for="data_inicial_pagar"
                    label="Data Inicial Venc."
                  >
                    <b-form-input type="date" v-model="data_inicial_pagar">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_pagar"
                    label-for="data_final_pagar"
                    label="Data Final Venc."
                  >
                    <b-form-input type="date" v-model="data_final_pagar">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    id="statusSelecionadoPagar"
                    label-for="statusSelecionadoPagar"
                    label="Status"
                    class="mr-5"
                  >
                    <b-form-select v-model="statusSelecionadoPagar">
                      <b-form-select-option
                        v-for="s in statusContaPagar"
                        :key="s.id + 'status'"
                        :value="s.descricao"
                      >
                        {{ s.descricao }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Fornecedor" label-for="nome">
                    <VueSelect
                      ref="buscarCliente"
                      :filterable="false"
                      @input="setFornecedorContasPagar"
                      :options="fornecedores"
                      @search="onSearchFornecedor"
                      v-model="fornecedor_conta_pagar"
                    >
                      <template slot="no-options">
                        Informe o nome do cliente
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.nome }}
                          </div>
                          <span class="text-muted">{{
                            formatCpfCnpj(option.cnpj_cpf)
                          }}</span>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group
                    label="Escolha a ordenação"
                    label-for="ordenacao"
                  >
                    <select
                      name="ordenacao_conta_pagar"
                      id="ordenacao_conta_pagar"
                      v-model="ordenacao_conta_pagar"
                      class="form-control"
                    >
                      <option
                        v-for="(o, index) in ordenar_conta_pagar"
                        :value="o.campo"
                        :key="'campo' + index"
                      >
                        {{ o.descricao }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Considerar pela data de pagamento
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="data_pagamento" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Simplificado
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input
                          type="checkbox"
                          v-model="contas_pagar_simplificado"
                        />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Somar por plano de contas
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="plano_conta" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
              </b-row>
              <b-dropdown text="Gerar relatório" variant="primary">
                <b-dropdown-item @click="gerarContasPagar(false)">PDF</b-dropdown-item>
                <b-dropdown-item @click="gerarContasPagar(true)">Excel</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-form>
        </div>
      </b-col>

      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Cobranças:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_cobranca"
                    label-for="data_inicial_cobranca"
                    label="Data Inicial"
                  >
                    <b-form-input type="date" v-model="data_inicial_cobranca">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_cobranca"
                    label-for="data_final_cobranca"
                    label="Data Final"
                  >
                    <b-form-input type="date" v-model="data_final_cobranca">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Totalizar por cliente
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="totalizacao_cliente" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Considerar pela data de emissão
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="considerar_emissao" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
              </b-row>
              <button
                @click="gerarCobrancas()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>

      <b-col v-if="isNuts" md="4">
        <div class="card card-custom gutter-b h-100">
          <div class="card-body d-flex flex-column">
            <h4>Inadimplência:</h4>
            <p class="text-muted flex-grow-1">
              Compare clientes finais e parceiros por saldo vencido, faixa de
              atraso e participação na inadimplência.
            </p>
            <b-button
              :to="{ name: 'relatorioInadimplencia' }"
              variant="primary"
              class="align-self-start font-weight-bold"
            >
              Visualizar
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <hr />
    <h4>Movimento Caixa</h4>
    <b-row>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Movimento Caixa:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_movimento"
                    label-for="data_inicial_movimento"
                    label="Data Inicial"
                  >
                    <b-form-input type="date" v-model="data_inicial_movimento">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_movimento"
                    label-for="data_final_movimento"
                    label="Data Final"
                  >
                    <b-form-input type="date" v-model="data_final_movimento">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Considerar vendas do período informado
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="considerar_vendas" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Apresentar plano de contas
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="plano_contas" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
              </b-row>
              <button
                @click="gerarMovimentoCaixa()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4" v-if="currentUser.admin">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Fechamento de Caixa:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_fechamento"
                    label-for="data_inicial_fechamento"
                    label="Data Inicial"
                  >
                    <b-form-input type="date" v-model="data_inicial_fechamento">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_fechamento"
                    label-for="data_final_fechamento"
                    label="Data Final"
                  >
                    <b-form-input type="date" v-model="data_final_fechamento">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Selecione o usuário/vendedor"
                    label-for="usuario_caixa"
                  >
                    <select
                      name="usuario_caixa"
                      id="usuario_caixa"
                      v-model="usuario_caixa"
                      class="form-control"
                    >
                      <option
                        v-for="(u, index) in usuarios"
                        :value="u"
                        :key="'id_usuario' + index"
                      >
                        {{ u.nome }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Fechamento às cegas
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input
                          type="checkbox"
                          v-model="fechamento_as_cegas_relatorio"
                        />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
              </b-row>
              <b-dropdown text="Gerar relatório" variant="primary">
                <b-dropdown-item @click="gerarFechamentoCaixa(false)">PDF</b-dropdown-item>
                <b-dropdown-item @click="gerarFechamentoCaixa(true)">Excel</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4" v-if="currentUser.admin">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Disponibilidade financeira:</h4>
              <p class="text-muted mb-6">
                Saldos atuais dos caixas abertos por usuário e das contas
                bancárias da empresa.
              </p>
              <button
                @click="gerarDisponibilidadeFinanceira()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
    <hr />
    <h4>Comissões</h4>
    <b-row>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Comissão por vendedor:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_comissao"
                    label-for="data_inicial_comissao"
                    label="Data Inicial"
                  >
                    <b-form-input type="date" v-model="data_inicial_comissao">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_comissao"
                    label-for="data_final_comissao"
                    label="Data Final"
                  >
                    <b-form-input type="date" v-model="data_final_comissao">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group label="Vendedor" label-for="vendedor">
                    <VueSelect
                      ref="buscaVendedor"
                      :filterable="false"
                      @input="setVendedor"
                      :options="vendedores"
                      v-model="vendedor"
                      @open="onSearchVendedor"
                      @search="onSearchVendedor"
                    >
                      <template slot="no-options">
                        Informe o nome do vendedor
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.nome }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.nome }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Apresentar os itens
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="apresentar_itens" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Verificar parcelas
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input type="checkbox" v-model="verificar_parcelas" />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
                <div class="border-bottom border-light py-3">
                  <b-col md="12">
                    <p class="font-weight-bolder text-dark mb-2">
                      Comissões simplificado
                    </p>
                    <span class="switch switch-icon">
                      <label v-b-tooltip.hover.right="'Não/Sim'">
                        <input
                          type="checkbox"
                          v-model="comissoes_simplificado"
                        />
                        <span></span>
                      </label>
                    </span>
                  </b-col>
                </div>
              </b-row>
              <button
                @click="gerarComissao()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";
import swal from "sweetalert";
import _ from "lodash";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  REPORT_PROCESSING_MESSAGE,
  REPORT_WITHOUT_PERIOD_MESSAGE,
} from "@/modules/Relatorios/services/reportGeneration";
import RelatorioEmpresasSelector from "@/modules/Relatorios/components/RelatorioEmpresasSelector.vue";

export default {
  name: "relatorios-financeiro",
  mixins: [SistemaMixin, PessoaMixin],
  data() {
    return {
      data_inicial: null,
      data_final: null,
      data_inicial_pagar: null,
      data_final_pagar: null,
      data_inicial_movimento: null,
      data_final_movimento: null,
      data_final_comissao: null,
      data_inicial_comissao: null,
      comissoes_simplificado: false,
      data_inicial_cobranca: null,
      data_final_cobranca: null,
      vendedor: null,
      vendedores: [],
      statusSelecionadoReceber: "Todos",
      statusSelecionadoPagar: "Todos",
      statusContaReceber: [
        {
          id: 1,
          descricao: "Vencida",
        },
        {
          id: 2,
          descricao: "A receber",
        },
        {
          id: 3,
          descricao: "Vencida e A receber",
        },
        {
          id: 4,
          descricao: "Recebida",
        },
        {
          id: 5,
          descricao: "Todos",
        },
        {
          id: 6,
          descricao: "Inativa",
        },
      ],
      statusContaPagar: [
        {
          id: 1,
          descricao: "Paga",
        },
        {
          id: 2,
          descricao: "Atrasada",
        },
        {
          id: 3,
          descricao: "Pendente",
        },
        {
          id: 4,
          descricao: "Atrasada e Pendente",
        },
        {
          id: 5,
          descricao: "Todos",
        },
      ],
      data_recebimento: false,
      data_pagamento: false,
      formato_simplificado: false,
      considerar_vendas: false,
      plano_contas: false,
      contas_pagar_simplificado: false,
      plano_conta: false,
      apresentar_itens: false,
      clientes: [],
      cliente_conta_receber: null,
      clienteContaReceber: null,
      meiosPagamento: [],
      meiosPagamentoSelecionados: [],
      verificar_parcelas: false,
      fornecedores: [],
      fornecedor_conta_pagar: null,
      fornecedorContaPagar: null,
      totalizacao_cliente: false,
      considerar_emissao: false,
      ordenacao_conta_receber: "data_vencimento",
      ordenacao_conta_pagar: "data_vencimento",
      ordenar_conta_receber: [
        {
          campo: "cliente",
          descricao: "Cliente",
        },
        {
          campo: "data_vencimento",
          descricao: "Data Vencimento",
        },
      ],
      ordenar_conta_pagar: [
        {
          campo: "cliente",
          descricao: "Fornecedor",
        },
        {
          campo: "data_vencimento",
          descricao: "Data Vencimento",
        },
      ],
      usuarios: [],
      usuario_caixa: null,
      fechamento_as_cegas_relatorio: false,
      data_final_fechamento: null,
      data_inicial_fechamento: null,
    };
  },
  components: {
    VueSelect,
    RelatorioEmpresasSelector,
  },
  methods: {
    async getDataInit() {
      const response = await this.$http.post("/usuario/get-usuarios");

      if (response) {
        this.usuarios = response.data;
      }
      const meios = await this.$http.post("/financeiro/meios-pagamento");
      this.meiosPagamento = Array.isArray(meios.data) ? meios.data : [];
    },
    setClienteContaReceber(cliente) {
      if (!cliente) {
        this.cliente_conta_receber = null;
        this.clienteContaReceber = null;
        return;
      }

      this.cliente_conta_receber = cliente.nome;
      this.clienteContaReceber = cliente;
    },
    setFornecedorContasPagar(cliente) {
      if (!cliente) {
        this.fornecedor_conta_pagar = null;
        this.fornecedorContaPagar = null;
        return;
      }

      this.fornecedor_conta_pagar = cliente.nome;
      this.fornecedorContaPagar = cliente;
    },
    getStatusContaReceberRelatorio() {
      if (this.statusSelecionadoReceber === "Vencida e A receber") {
        return ["Vencida", "A receber"];
      }

      return this.statusSelecionadoReceber ?? null;
    },
    getStatusContaPagarRelatorio() {
      if (this.statusSelecionadoPagar === "Atrasada e Pendente") {
        return ["Atrasada", "Pendente"];
      }

      return this.statusSelecionadoPagar ?? null;
    },
    gerarContasReceber(gerarExcel = false) {
      const hasPeriodo = this.data_inicial && this.data_final;
      const hasCliente = this.clienteContaReceber?.id_pessoa;

      if ((this.data_inicial || this.data_final) && !hasPeriodo) {
        this.$toast.warning(
          "Informe a data inicial e final para gerar o relatório por período!"
        );
        return;
      }

      if (!hasPeriodo && !hasCliente) {
        this.$toast.warning(
          "Informe as datas ou selecione um cliente para gerar o relatório!"
        );
        return;
      }

      swal({
        title: gerarExcel
          ? "Deseja gerar o relatório em arquivo .xlsx?"
          : "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/receitas", {
            data_inicial: this.data_inicial,
            data_final: this.data_final,
            status: this.getStatusContaReceberRelatorio(),
            data_recebimento: this.data_recebimento ?? null,
            id_pessoa: this.clienteContaReceber?.id_pessoa ?? null,
            formato_simplificado: this.formato_simplificado ?? false,
            ordenacao_conta_receber: this.ordenacao_conta_receber ?? null,
            ids_meios_pagamento: this.meiosPagamentoSelecionados.map((meio) => meio.id),
            gerar_em_excel: gerarExcel,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarContasPagar(gerarExcel = false) {
      const hasPeriodo = this.data_inicial_pagar && this.data_final_pagar;
      const hasFornecedor = this.fornecedorContaPagar?.id_pessoa;

      if ((this.data_inicial_pagar || this.data_final_pagar) && !hasPeriodo) {
        this.$toast.warning(
          "Informe a data inicial e final para gerar o relatório por período!"
        );
        return;
      }

      if (!hasPeriodo && !hasFornecedor) {
        this.$toast.warning(
          "Informe as datas ou selecione um fornecedor para gerar o relatório!"
        );
        return;
      }

      swal({
        title: gerarExcel
          ? "Deseja gerar o relatório em arquivo .xlsx?"
          : "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/despesas", {
            data_inicial: this.data_inicial_pagar,
            data_final: this.data_final_pagar,
            status: this.getStatusContaPagarRelatorio(),
            data_pagamento: this.data_pagamento ?? null,
            contas_pagar_simplificado: this.contas_pagar_simplificado ?? false,
            plano_conta: this.plano_conta ?? false,
            id_pessoa: this.fornecedorContaPagar?.id_pessoa ?? null,
            ordenacao_conta_pagar: this.ordenacao_conta_pagar ?? null,
            gerar_em_excel: gerarExcel,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarMovimentoCaixa() {
      if (!this.data_inicial_movimento || !this.data_final_movimento) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/movimento-caixa", {
            data_inicial: this.data_inicial_movimento,
            data_final: this.data_final_movimento,
            considerar_vendas: this.considerar_vendas,
            plano_contas: this.plano_contas ?? false,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarFechamentoCaixa(gerarExcel = false) {
      if (!this.data_inicial_fechamento || !this.data_final_fechamento) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      if (!this.fechamento_as_cegas_relatorio && !this.usuario_caixa) {
        this.$toast.warning(
          "Selecione o usuário/vendedor para gerar o relatório!"
        );
        return;
      }
      swal({
        title: gerarExcel
          ? "Deseja gerar o relatório em arquivo .xlsx?"
          : "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/fechamento-caixa", {
            data_inicial: this.data_inicial_fechamento,
            data_final: this.data_final_fechamento,
            usuario: this.usuario_caixa ?? null,
            fechamento_as_cegas: this.fechamento_as_cegas_relatorio ?? false,
            gerar_em_excel: gerarExcel,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarDisponibilidadeFinanceira() {
      swal({
        title: "Deseja gerar o relatório de disponibilidade financeira?",
        text: REPORT_WITHOUT_PERIOD_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/disponibilidade-financeira")
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    setVendedor(vendedor) {
      this.vendedor = vendedor;
    },
    gerarCobrancas() {
      if (!this.data_inicial_cobranca || !this.data_final_cobranca) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/cobrancas", {
            data_inicial: this.data_inicial_cobranca,
            data_final: this.data_final_cobranca,
            totalizacao_cliente: this.totalizacao_cliente,
            considerar_emissao: this.considerar_emissao,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    async gerarComissao() {
      if (!this.data_inicial_comissao || !this.data_final_comissao) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }

      return this.gerarComissaoSimples();
    },
    gerarComissaoSimples() {
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/comissao", {
            data_inicial: this.data_inicial_comissao,
            data_final: this.data_final_comissao,
            id_vendedor: this.vendedor?.id_vendedor ?? null,
            apresentar_itens: this.apresentar_itens ?? false,
            verificar_parcelas: this.verificar_parcelas ?? false,
            comissoes_simplificado: this.comissoes_simplificado ?? false,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    async gerarComissaoComFinanceiro() {
      try {
        const response = await this.$http.post("/relatorios/comissao/preview", {
          data_inicial: this.data_inicial_comissao,
          data_final: this.data_final_comissao,
          id_vendedor: this.vendedor?.id_vendedor ?? null,
        });

        const { vendedores, total_geral, periodo } = response.data.data;

        if (!vendedores || vendedores.length === 0) {
          this.$toast.warning(
            "Nenhum vendedor com comissão encontrada no período informado!"
          );
          return;
        }

        const vendedoresComComissao = vendedores.filter(
          (v) => v.total > 0
        );

        if (vendedoresComComissao.length === 0) {
          this.$toast.warning(
            "Nenhum vendedor possui comissão maior que zero no período!"
          );
          return;
        }

        let tabelaHtml =
          '<div style="max-height:400px;overflow-y:auto;">' +
          '<table style="width:100%;border-collapse:collapse;font-size:14px;">' +
          "<thead>" +
          '<tr style="background:#f8f9fa;">' +
          '<th style="padding:8px;border:1px solid #dee2e6;text-align:left;">Vendedor</th>' +
          '<th style="padding:8px;border:1px solid #dee2e6;text-align:right;">À Vista</th>' +
          '<th style="padding:8px;border:1px solid #dee2e6;text-align:right;">A Prazo</th>' +
          '<th style="padding:8px;border:1px solid #dee2e6;text-align:right;">Total</th>' +
          "</tr>" +
          "</thead>" +
          "<tbody>";

        vendedoresComComissao.forEach((v) => {
          tabelaHtml +=
            "<tr>" +
            '<td style="padding:8px;border:1px solid #dee2e6;text-align:left;">' +
            v.nome +
            "</td>" +
            '<td style="padding:8px;border:1px solid #dee2e6;text-align:right;">R$ ' +
            this.formatMoeda(v.comissao_vista) +
            "</td>" +
            '<td style="padding:8px;border:1px solid #dee2e6;text-align:right;">R$ ' +
            this.formatMoeda(v.comissao_prazo) +
            "</td>" +
            '<td style="padding:8px;border:1px solid #dee2e6;text-align:right;font-weight:bold;">R$ ' +
            this.formatMoeda(v.total) +
            "</td>" +
            "</tr>";
        });

        tabelaHtml +=
          "</tbody>" +
          '<tfoot><tr style="background:#e9ecef;font-weight:bold;">' +
          '<td colspan="3" style="padding:8px;border:1px solid #dee2e6;text-align:right;">TOTAL GERAL:</td>' +
          '<td style="padding:8px;border:1px solid #dee2e6;text-align:right;">R$ ' +
          this.formatMoeda(total_geral) +
          "</td>" +
          "</tr></tfoot>" +
          "</table></div>";

        var wrapper = document.createElement("div");
        wrapper.innerHTML =
          "<p style='margin-bottom:10px;'><strong>Período:</strong> " +
          periodo +
          "</p>" +
          "<p style='margin-bottom:10px;color:#dc3545;'>" +
          "<strong>Atenção:</strong> Ao confirmar, serão geradas contas a pagar no financeiro " +
          "para cada vendedor listado abaixo (apenas os totais).</p>" +
          tabelaHtml +
          "<div style='margin-top:15px;'>" +
          "<label style='display:block;margin-bottom:5px;font-weight:bold;'>" +
          "Data de Vencimento das Contas:" +
          "</label>" +
          "<input type='date' id='swal-data-vencimento' " +
          "value='" +
          this.data_final_comissao +
          "' " +
          "style='width:100%;padding:8px;border:1px solid #ced4da;border-radius:4px;font-size:14px;' />" +
          "</div>";

        swal({
          title: "Gerar financeiro de comissões?",
          content: wrapper,
          icon: "warning",
          buttons: {
            cancel: {
              text: "Cancelar",
              value: "cancel",
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: "Gerar e Confirmar",
              visible: true,
              closeModal: false,
            },
          },
          dangerMode: true,
          closeModal: false,
          closeOnClickOutside: false,
        }).then(async (value) => {
          if (value === "cancel") {
            swal.close();
            swal.stopLoading();
            return;
          }

          var inputVencimento = document.getElementById(
            "swal-data-vencimento"
          );
          var dataVencimento = inputVencimento
            ? inputVencimento.value
            : this.data_final_comissao;

          if (!dataVencimento) {
            swal.stopLoading();
            swal.close();
            this.$toast.warning(
              "Informe a data de vencimento para as contas a pagar!"
            );
            return;
          }

          await this.$http
            .post("/relatorios/comissao", {
              data_inicial: this.data_inicial_comissao,
              data_final: this.data_final_comissao,
              id_vendedor: this.vendedor?.id_vendedor ?? null,
              apresentar_itens: this.apresentar_itens ?? false,
              verificar_parcelas: this.verificar_parcelas ?? false,
              comissoes_simplificado: this.comissoes_simplificado ?? false,
              gerar_financeiro: true,
              data_vencimento_comissao: dataVencimento,
            })
            .then(() => {
              swal.stopLoading();
              swal.close();
              this.$toast.success(
                "Contas a pagar geradas e relatório solicitado com sucesso!"
              );
            })
            .catch(() => {
              swal.stopLoading();
              swal.close();
            });
        });
      } catch (error) {
        this.$toast.error(
          "Erro ao buscar prévia das comissões. Tente novamente."
        );
      }
    },
    formatMoeda(valor) {
      if (valor === null || valor === undefined) return "0,00";
      return Number(valor)
        .toFixed(2)
        .replace(".", ",");
    },
    onSearchVendedor(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchVendedor(busca.loading, busca.termo, this);
    },
    searchVendedor: _.debounce(async (loading, search, vm) => {
      vm.vendedores = await vm.getVendedorByNome(search);
      if (loading) loading(false);
    }, 350),
    onSearchCliente(search, loading) {
      const termo = search.trim();

      if (termo.length > 2) {
        loading(true);
        this.searchCliente(loading, termo, this);
        return;
      }

      this.searchCliente.cancel();
      this.clientes = [];
      if (loading) loading(false);
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getClientes(search);
      loading(false);
    }, 500),
    onSearchFornecedor(search, loading) {
      const termo = search.trim();

      if (termo.length > 2) {
        loading(true);
        this.searchFornecedor(loading, termo, this);
        return;
      }

      this.searchFornecedor.cancel();
      this.fornecedores = [];
      if (loading) loading(false);
    },

    searchFornecedor: _.debounce(async (loading, search, vm) => {
      vm.fornecedores = await vm.getFornecedorByNome(search);
      loading(false);
    }, 350),
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked", "isNuts"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    config() {
      return this.layoutConfig();
    },
  },
  async mounted() {
    await this.getDataInit();
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    console.log(this.currentUser.admin);
  },
};
</script>
